import {useForm} from 'antd/es/form/Form';
import {Moment} from 'moment';
import {
    useCallback, useEffect, useRef, useState, Dispatch, SetStateAction,
} from 'react';

import {IModalOpenerComponentRef} from 'components/modal-opener-component';
import {TEntity, resetLoadedData} from 'modules/data';
import {EEntityType} from 'shared/constants/entities';
import {showMessageFromResponse} from 'shared/utils';
import {useAppDispatch} from 'store/config/hooks';

import {ISendProjectInvestmentInfoServiceArgs, sendProjectInvestmentInfoService} from '../api';

interface IProjectInvestmentInfoServiceForm {
    serviceName: string;
    reportingDate: Moment;
    reportingYear: number;
    adjNumber: number;
    hasInvestmentProject: string;
}

interface IUseProjectInvestmentInfoServiceModalArgs {
    serviceName?: string;
    selectedRows: TEntity[] | undefined;
    entityName: string;
}

export const useProjectInvestmentInfoServiceModal = ({
    serviceName = 'Сервис отправки сведений об инвестиционных проектах',
    selectedRows,
    entityName,
}: IUseProjectInvestmentInfoServiceModalArgs) => {
    const [form] = useForm<IProjectInvestmentInfoServiceForm>();
    const modalRef = useRef<IModalOpenerComponentRef>(null);
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (isOpen) {
            form.setFieldsValue({
                serviceName,
            });
        }
    }, [isOpen, serviceName, form, selectedRows]);

    const handleFinish = useCallback(async () => {      
        try {
            const formValues = form.getFieldsValue();

            const payload: ISendProjectInvestmentInfoServiceArgs = {
                reportingDate: formValues.reportingDate.format('YYYY-MM-DD'),
                reportingYear: Number(formValues.reportingYear),
                adjNumber: Number(formValues.adjNumber),
                hasInvestmentProject: Number(formValues.hasInvestmentProject),
            } as ISendProjectInvestmentInfoServiceArgs;

            const response = await sendProjectInvestmentInfoService({...payload});
            showMessageFromResponse(response);
            modalRef.current?.setIsModalOpen(false);
            form.resetFields();
            dispatch(resetLoadedData(entityName, EEntityType.TABLE));
        } catch (error) {
            showMessageFromResponse({response: error, isError: true});
        }
    }, [form, modalRef, selectedRows, entityName, dispatch]);

    const handleCloseModal = useCallback((setIsModalOpen: Dispatch<SetStateAction<boolean>>) => {
        form.resetFields();
        setIsModalOpen(false);
    }, [form]);

    return {
        modalRef,
        isOpen,
        form,
        setIsOpen,
        handleCloseModal,
        handleFinish,
    };
};

